<div class="barcode-reader">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <mat-form-field appearance="outline">
        <mat-label>{{
          "Barcode"
          | translate
          : [
          "tmc-yard.widgets.yard-simulator.barcode-reader",
          translationService.language
          ]
          }}</mat-label>
        <mat-select (valueChange)="onBarcodeReaderSelection($event)">
          <mat-option *ngFor="let barcodeReader of barcodeReaders" [value]="barcodeReader">
            {{ barcodeReader.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <sc-flex [vertical]="true" [stretchContent]="true">
        <sc-string-field formControlName="scannedNumber" [label]="
            'Barcode'
              | translate
                : [
                    'tmc-yard.widgets.yard-simulator.barcode-protocol',
                    translationService.language
                  ]
          " [required]="true">
        </sc-string-field>
      </sc-flex>
    </form>

    <button mat-flat-button class="config-changed-button" (click)="onButtonTrigger()"
      [disabled]="!scannedNumber || !barcodeReaderSelected">
      {{
      "send"
      | translate
      : [
      "tmc-yard.widgets.yard-simulator.send",
      translationService.language
      ]
      }}
    </button>
  </sc-padding>
</div>
